// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2hUPs","questions":"styles_questions__16EBQ","footer":"styles_footer__37OvP"};